import axios from "axios";
const api = axios.create({ baseURL:"https://coop.heritageco-op.com/api" });
//const api = axios.create({ baseURL:"http://localhost:4000/api" });
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
api.interceptors.response.use(r => r.data, err => Promise.reject(err.response?.data||err));
export default api;
 